import { render, staticRenderFns } from "./changeInformation.vue?vue&type=template&id=5890f39c&"
import script from "./changeInformation.vue?vue&type=script&lang=js&"
export * from "./changeInformation.vue?vue&type=script&lang=js&"
import style0 from "./changeInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports